import { Button, Modal } from '@hue/design-system';
import { MapPin } from 'lucide-react';
import { useState } from 'react';

const configuredKey = import.meta.env.VITE_GOOGLE_MAPS_EMBED_KEY as string | undefined;

/// "Ver mapa" da unidade. O mapa embutido do Google só carrega quando a pessoa abre o diálogo: com
/// chave, pela Maps Embed API (gratuita, sem faturamento); sem chave, pelo endereço de incorporação
/// público do Google, que dispensa chave. Os links abrem o aplicativo já no endereço.
export function PortalUnitMap({
  unitName,
  address,
  embedKey = configuredKey,
}: {
  unitName: string;
  address: string;
  embedKey?: string | undefined;
}) {
  const [open, setOpen] = useState(false);
  const query = encodeURIComponent(address);
  const links = [
    {
      label: 'Abrir no Google Maps',
      href: `https://www.google.com/maps/search/?api=1&query=${query}`,
    },
    { label: 'Abrir no Waze', href: `https://waze.com/ul?q=${query}&navigate=yes` },
    { label: 'Abrir no Apple Mapas', href: `https://maps.apple.com/?q=${query}` },
  ];
  const src = embedKey
    ? `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(embedKey)}&q=${query}&language=pt-BR&region=BR`
    : `https://maps.google.com/maps?q=${query}&hl=pt-BR&z=16&output=embed`;
  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)}>
        <MapPin className="size-4" aria-hidden="true" />
        Ver mapa
      </Button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        title={unitName}
        description={address}
        footer={
          <div className="flex flex-wrap gap-3">
            {links.map((link) => (
              <Button key={link.label} asChild variant="outline">
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.label}
                </a>
              </Button>
            ))}
          </div>
        }
      >
        <iframe
          title={`Mapa de ${unitName}`}
          src={src}
          className="aspect-[4/3] w-full rounded-xl border border-surface-border"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </Modal>
    </>
  );
}
